import React, { useState } from "react";
import axios from "axios";
import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalBody,
} from "@chakra-ui/modal";
import Card from "components/card";
import { Button } from '@chakra-ui/react';
import DisplayAmount from "../../shared/DisplayAmount";

const BatchCancelConfirmModal: React.FC<{
    batchToCancel: any;
    isOpen: boolean;
    onClose(): void;
    triggerReload(): void;
    setSwalProps: any;
}> = ({ isOpen, onClose, triggerReload, batchToCancel, setSwalProps }) => {

    const [isProcessing, setIsProcessing] = useState<boolean>(false);
    const userRole = localStorage.getItem("userRole")?.toLowerCase();

    const closeModal = async () => {
        onClose();
    };

    const handleSubmit = async () => {
        try {
            setIsProcessing(true);

            const data = {
                username: localStorage.getItem("username"),
                userRole: userRole,
                subaccount_id: batchToCancel.subaccount.id
            }

            await axios.put(process.env.REACT_APP_API_URL + `/api/batch/cancel/${batchToCancel.id}`, data)
                .then(function (response) {                    
                    if (response && response.data?.status === 'ok') {
                        onClose();
                        setSwalProps({
                            show: true,
                            icon: "success",
                            title: "Success",
                            html: "Batch has been cancel",
                            showConfirmButton: true,
                            didClose: () => {
                                triggerReload();                                
                                setSwalProps({});
                                setIsProcessing(false);
                            },
                        });
                    } else {
                        setIsProcessing(false);
                    }
                })
                .catch(function (error) {
                    setIsProcessing(false);
                    setSwalProps({
                        show: true,
                        icon: "error",
                        title: "Oops!",
                        html: error.response.data.message,
                        showConfirmButton: true,
                        didClose: () => {
                            setSwalProps({});
                            setIsProcessing(false);
                        },
                    });
                });
        } catch (error: any) {
            setIsProcessing(false);
            setSwalProps({
                show: true,
                icon: "error",
                title: "Oops!",
                html: "Something went wrong, please try again later.",
                showConfirmButton: true,
                didClose: () => {
                    setSwalProps({});
                    setIsProcessing(false);
                },
            });
        }
    };

    return (
        <>
            {batchToCancel &&
                <Modal isOpen={isOpen} onClose={onClose} closeOnOverlayClick={false}>
                    <ModalOverlay className="bg-[#000] !opacity-30" />
                    <ModalContent className="!z-[1002] !m-auto !w-max min-w-[350px] !max-w-[85%] md:top-[12vh]">
                        <ModalBody className="!text-navy-700">
                            <Card extra="px-[30px] pt-[35px] pb-[40px] max-w-[650px] flex flex-col !z-[1004]">
                                <h1 className="mb-[20px] text-2xl font-bold">Are you sure you want to cancel the batch?</h1>
                                <div className="mb-[20px text-sm">
                                    <div className="mb-8">
                                        Please confirm if you wish to cancel the current batch. Cancelling this batch will discard all the payout, and the transaction will not be processed.
                                    </div>
                                    {userRole === 'superadmin' && batchToCancel.provider_name && batchToCancel.provider_account_name && batchToCancel.provider_method_name &&
                                        <>
                                            <div className="mb-1">
                                                <span className="mr-1 font-bold">Provider:</span> {batchToCancel !== null && batchToCancel.provider_name !== null ? batchToCancel.provider_name + " (" + batchToCancel.provider_account_name + ")" : (<>{"-"}</>)}
                                            </div>
                                            <div className="mb-1">
                                                <span className="mr-1 font-bold">Provider Method:</span> {batchToCancel.provider_method_name}
                                            </div>
                                        </>
                                    }
                                    <div className="mb-1">
                                        <span className="mr-1 font-bold">Record(s):</span> {batchToCancel.record}
                                    </div>
                                    <div className="mb-1">
                                        <span className="mr-1 font-bold">Amount:</span> <DisplayAmount amount={Number(batchToCancel.amount)} currency={batchToCancel.asset} /> {batchToCancel.asset}
                                    </div>
                                </div>
                                <div className="flex gap-2 justify-end">
                                    <Button
                                        onClick={() => closeModal()}
                                        isDisabled={isProcessing}
                                        className="btn btn-default"
                                    >
                                        Close
                                    </Button>
                                    <Button
                                        onClick={() => handleSubmit()}
                                        isLoading={isProcessing}
                                        loadingText='Processing...'
                                        className="btn btn-primary">
                                        Confirm
                                    </Button>
                                </div>
                            </Card>
                        </ModalBody>
                    </ModalContent>
                </Modal>
            }
        </>
    );
};

export default BatchCancelConfirmModal;
